import { isInArray } from "utils/general";
import { OrderStatus, OrderStatusRankRange } from "../../entities"
// import { isExternalNotApproved } from "./entity";

export const checkIsRankDisabled = (values) =>{
    return values  && values["status"] ? 
        !OrderStatusRankRange.includes(values["status"]) :
           false;
} 

export const checkCustomerCanDeleteOrder = (order) =>{
    return order && isInArray([OrderStatus.DRAFT, OrderStatus.BOOKED], order.status);
}

export const checkCanCloneOrder = (order) =>{
    return order && order.status !== OrderStatus.DRAFT;
} 